(() => {
  const initReveal = (scope = document) => {
    const items = scope.querySelectorAll('[data-apex-reveal]:not([data-apex-ready])');
    if (!items.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      items.forEach((item) => {
        item.dataset.apexReady = 'true';
        item.classList.add('is-visible');
      });
      return;
    }

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    items.forEach((item) => {
      item.dataset.apexReady = 'true';
      observer.observe(item);
    });
  };

  const initStagger = (scope = document) => {
    scope.querySelectorAll('[data-apex-stagger]').forEach((group) => {
      [...group.children].forEach((child, index) => {
        child.style.setProperty('--apex-stagger-index', index);
      });
    });
  };

  const initAccordions = (scope = document) => {
    scope.querySelectorAll('[data-apex-accordion]').forEach((accordion) => {
      if (accordion.dataset.apexReady === 'true') return;
      accordion.dataset.apexReady = 'true';

      accordion.querySelectorAll('.apex-accordion__button').forEach((button) => {
        button.addEventListener('click', () => {
          const panelId = button.getAttribute('aria-controls');
          const panel = document.getElementById(panelId);
          const willOpen = button.getAttribute('aria-expanded') !== 'true';

          if (accordion.dataset.single === 'true') {
            accordion.querySelectorAll('.apex-accordion__button[aria-expanded="true"]').forEach((other) => {
              if (other === button) return;
              other.setAttribute('aria-expanded', 'false');
              const otherPanel = document.getElementById(other.getAttribute('aria-controls'));
              if (otherPanel) otherPanel.setAttribute('aria-hidden', 'true');
            });
          }

          button.setAttribute('aria-expanded', String(willOpen));
          if (panel) panel.setAttribute('aria-hidden', String(!willOpen));
        });
      });
    });
  };

  const init = (scope = document) => {
    initStagger(scope);
    initReveal(scope);
    initAccordions(scope);
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
